import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import Layout from "@/layout";
import utils from "../utils/auth.js";
import store from "@/store";
Vue.use(VueRouter);

let routes = [
    {
        path: "/",
        name: "Login",
        visible: true,
        meta: {
            title: "宏瓴科技",
            visible: true,
            menuId: 1,
        },
        component: () => import("../views/Login.vue"),
    },
];

let dynamicRoutesReady = false;

// 动态重置路由
function resetRoutes(routesData) {
    routes = [
        {
            path: "/vue/*",
            component: Layout,
        },
        {
            path: "/",
            name: "Login",
            visible: true,
            meta: {
                title: "宏瓴科技",
                visible: true,
                menuId: 1,
            },
            component: () => import("../views/Login.vue"),
        },
        {
            path: "/vehicleMap",
            name: "vehicleMap",
            meta: {
                title: "行程轨迹",
                visible: true,
                menuId: 3,
            },
            component: () => import("../views/maps/vehicleMap.vue"),
        },
    ];
    let userMenu = JSON.parse(localStorage.getItem("userMenu")) || []; //路由数据
    for (let i = 0; i < userMenu.length; i++) {
        let tmpUserMenu = userMenu[i];

        let tmpRoute = {
            path: tmpUserMenu.path,
            component: Layout,
            name: tmpUserMenu.path.slice(1, tmpUserMenu.path.length),
            meta: {
                title: tmpUserMenu.menuName,
                icon: tmpUserMenu.icon,
                menuId: tmpUserMenu.menuId,
                visible: Number(tmpUserMenu.visible),
            },
            children: [],
        };

        let childrenItem = {};
        if (tmpUserMenu.children && tmpUserMenu.children.length > 0) {
            for (let t = 0; t < tmpUserMenu.children.length; t++) {
                const tmpItem = tmpUserMenu.children[t];
                tmpItem.path = tmpItem.path.slice(1, tmpItem.path.length);
                childrenItem = {
                    path: tmpItem.path,
                    name: tmpItem.path,
                    meta: {
                        title: tmpItem.menuName,
                        icon: "el-icon-s-marketing",
                        menuId: tmpItem.menuId,
                        perms:
                            tmpItem.perms != tmpUserMenu.menuName
                                ? tmpItem.perms
                                : null,
                        component: tmpItem.component,
                        visible: Number(tmpItem.visible),
                    },
                };

                if (tmpUserMenu.path != "/vue") {
                    // childrenItem.component = () => import('@/views' + tmpItem.component + '/' + tmpItem.path + '.vue')
                    childrenItem.component = (resolve) =>
                        require([
                            "@/views" +
                                tmpItem.component +
                                "/" +
                                tmpItem.path +
                                ".vue",
                        ], resolve);
                }
                tmpRoute.children.push(childrenItem);
            }
        } else {
            // tmpRoute.component = () => import('@/views' + tmpUserMenu.path + '/' + tmpItem.path + '.vue')
            // tmpRoute.component = (resolve) =>
            //     require(["@/views" + tmpUserMenu.path + ".vue"], resolve);

            // childrenItem.component = (resolve) =>
            //     require(["@/views" + tmpUserMenu.path + "/index"], resolve);

            childrenItem = {
                path: "index",
                name: tmpUserMenu.menuName,
                meta: {
                    title: tmpUserMenu.menuName,
                    menuId: tmpUserMenu.menuId,
                    component: tmpUserMenu.component,
                },
            };
            childrenItem.component = (resolve) =>
                require(["@/views" + tmpUserMenu.path + "/index"], resolve);
            tmpRoute.children.push(childrenItem);
        }
        routes.push(tmpRoute);
    }
    // console.log('整理路由：')
    // console.log(routes)
    localStorage.setItem("routes", JSON.stringify(routes));
    dynamicRoutesReady = true;
}

let router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

function getRetryKey(fullPath) {
    return "router_retry_" + fullPath;
}

function getFirstAccessibleRoute() {
    const userMenu = JSON.parse(localStorage.getItem("userMenu")) || [];
    const defaultRoute = {
        path: "/vehicle/vehicleManage",
        menuId: null,
    };
    if (!userMenu.length) {
        return defaultRoute;
    }

    for (let i = 0; i < userMenu.length; i++) {
        const menu = userMenu[i];
        if (menu.path === "/vehicle" && menu.children && menu.children.length) {
            const vehicleManage = menu.children.find(
                (child) => child.path === "/vehicleManage"
            );
            if (vehicleManage) {
                return {
                    path: menu.path + vehicleManage.path,
                    menuId: menu.menuId || null,
                };
            }
        }
    }

    for (let i = 0; i < userMenu.length; i++) {
        const menu = userMenu[i];
        if (menu.children && menu.children.length) {
            const firstVisibleChild = menu.children.find(
                (child) => Number(child.visible) !== 0
            );
            if (firstVisibleChild) {
                return {
                    path: menu.path + firstVisibleChild.path,
                    menuId: menu.menuId || null,
                };
            }
        } else if (Number(menu.visible) !== 0) {
            return {
                path: menu.path === "/Home" ? menu.path : menu.path + "/index",
                menuId: menu.menuId || null,
            };
        }
    }

    return defaultRoute;
}

function fallbackToAccessiblePage(next) {
    const fallbackRoute = getFirstAccessibleRoute();
    if (fallbackRoute.path === window.location.pathname) {
        next({
            replace: true,
            path: "/",
        });
        return;
    }
    if (fallbackRoute.menuId != null) {
        localStorage.setItem("checkedMenuId", fallbackRoute.menuId);
    }
    localStorage.setItem("jumpPath", fallbackRoute.path);
    next({
        replace: true,
        path: fallbackRoute.path,
    });
}

function ensureDynamicRoutes() {
    if (dynamicRoutesReady || !localStorage.getItem("userMenu")) {
        return false;
    }
    resetRoutes();
    routes.forEach((v) => {
        router.addRoute(v);
    });
    return true;
}

ensureDynamicRoutes();

// 防止重复跳转
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

// 路由守卫
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    if (to.matched.length > 0) {
        sessionStorage.removeItem(getRetryKey(to.fullPath));
    }

    if (to.matched.length === 0) {
        if (utils.getToken()) {
            if (ensureDynamicRoutes()) {
                sessionStorage.setItem(getRetryKey(to.fullPath), "1");
                next({
                    replace: true,
                    path: to.fullPath,
                });
                return;
            }
            if (!sessionStorage.getItem(getRetryKey(to.fullPath))) {
                sessionStorage.setItem(getRetryKey(to.fullPath), "1");
                next({
                    replace: true,
                    path: to.fullPath,
                });
                return;
            }
            sessionStorage.removeItem(getRetryKey(to.fullPath));
            fallbackToAccessiblePage(next);
        } else {
            next({
                replace: true,
                name: "Login",
            });
        }
        return;
    }

    // 检测path首字母是否大写字母
    to.path != "/Home" && pathNameCapitalization(to.path);

    if (
        to.fullPath.indexOf("redirect") != -1 &&
        localStorage.getItem("tokenError") == 401
    ) {
        next({
            replace: true,
            name: "首页",
            path: "/",
        });
    }

    if (to.path == "/vue/") {
        next({
            replace: true,
            name: "首页",
            path: "/",
        });
    }

    if (utils.getToken()) {
        let jumpPath = localStorage.getItem("jumpPath");

        store.dispatch("common/getLocalUserInfo");

        if (!jumpPath) {
            next();
            return;
        }

        if (to.path == "/") {
            fallbackToAccessiblePage(next);
            return;
        }

        next();
    } else {
        if (to.path == "/") {
            next();
        } else {
            // localStorage.setItem("redirectPath", to.fullPath);
            next({
                replace: true,
                name: "Login",
            });
        }
    }
});

function pathNameCapitalization(routePath) {
    let tmpPath = routePath;
    let tmpLastIndex = tmpPath.lastIndexOf("/");
    let path = tmpPath.slice(tmpLastIndex + 1, tmpPath.length);
    let capitalization = /^[A-Z]/.test(path);
    if (capitalization) {
        localStorage.clear();
        sessionStorage.clear();
        location.href = "/";
    }
}

export function handleMenuData(data) {
    localStorage.removeItem("headerMenus");
    localStorage.removeItem("routes");
    data && resetRoutes(data);
}

export default router;
